import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Building2, MapPin, ChevronRight, Loader2 } from 'lucide-react';
import { edificiosApi, unidadesApi } from '../../lib/api';
import { StatusBadge } from '../../components/common/StatusBadge';

export default function RevisorEdificios() {
  const navigate = useNavigate();
  const [edificios, setEdificios] = useState([]);
  const [unidadesCounts, setUnidadesCounts] = useState({});
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    (async () => {
      try {
        const edRes = await edificiosApi.list();
        const eds = edRes.data || [];
        setEdificios(eds);
        const counts = {};
        await Promise.all(eds.map(async (e) => {
          try {
            const uRes = await unidadesApi.list({ edificio_id: e.edificio_id });
            counts[e.edificio_id] = (uRes.data || []).length;
          } catch { counts[e.edificio_id] = 0; }
        }));
        setUnidadesCounts(counts);
      } finally { setLoading(false); }
    })();
  }, []);

  if (loading) {
    return (
      <div className="p-8 flex items-center justify-center">
        <Loader2 className="w-6 h-6 animate-spin text-slate-400" />
      </div>
    );
  }

  return (
    <div className="p-4 md:p-8">
      <div className="mb-6">
        <div className="flex items-center gap-3">
          <div className="w-10 h-10 rounded-lg bg-indigo-100 flex items-center justify-center">
            <Building2 className="w-5 h-5 text-indigo-700" />
          </div>
          <div>
            <h1 className="text-2xl md:text-3xl font-bold text-slate-900">Edificios</h1>
            <p className="text-slate-500 mt-1">Vista de control para revisión</p>
          </div>
        </div>
      </div>

      {edificios.length === 0 ? (
        <div className="text-center py-16 text-slate-500 bg-white border border-slate-200 rounded-lg">
          No hay edificios cargados.
        </div>
      ) : (
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
          {edificios.map((e) => (
            <button
              key={e.edificio_id}
              onClick={() => navigate(`/revisor/edificio/${e.edificio_id}`)}
              className="group bg-white border border-slate-200 rounded-lg p-5 text-left hover:border-indigo-400 hover:shadow-md transition"
              data-testid={`revisor-edificio-card-${e.edificio_id}`}
            >
              <div className="flex items-start justify-between mb-3">
                <h3 className="text-lg font-semibold text-slate-900">{e.nombre}</h3>
                <StatusBadge status={e.estado} />
              </div>
              <p className="flex items-center gap-1 text-sm text-slate-500 mb-3">
                <MapPin className="w-3.5 h-3.5" /> {e.direccion}
              </p>
              <div className="flex items-center justify-between text-sm">
                <span className="text-slate-600">{unidadesCounts[e.edificio_id] ?? 0} unidades</span>
                <ChevronRight className="w-4 h-4 text-slate-400 group-hover:text-indigo-600" />
              </div>
            </button>
          ))}
        </div>
      )}
    </div>
  );
}
